import { translate, translateFormatter } from '@/domains/core/localization/translate';
export const {
  termsTitle,
  termsLineRestrictionText,
  termsLine1,
  termsLine2,
  termsLine3,
  line1Translation,
  line2Translation,
  line3Translation,
  useIndication,
  userCouponsHowToTitle,
  userCouponsHowToContent,
  userCouponsConditionsTitle,
  userCouponsConditionsCatalogue,
  userCouponsConditionsNonCombinable
} = translate({
  "termsTitle": "Coupon terms",
  "termsLineRestrictionText": "The Coupon is only applicable to the product listed on this product page.",
  "termsLine1": "This voucher can only be applied to one item per basket and cannot be combined with any other discount codes.",
  "termsLine2": "The Coupon is applicable on the current basket and cannot be kept.",
  "termsLine3": "The coupon is valid for a limited period only.",
  "line1Translation": "Le Coupon n\u2019est applicable que sur un seul groupe de produits propos\xE9 par ManoMano sur lequel le coupon est propos\xE9.",
  "line2Translation": "Le Coupon est applicable sur le panier en cours et il ne peut pas \xEAtre conserv\xE9",
  "line3Translation": "Le Coupon n'est valide que pour une p\xE9riode limit\xE9e.",
  "useIndication": "To enter on the payment page",
  "userCouponsHowToTitle": "How does it work?",
  "userCouponsHowToContent": "Copy the code now and proceed to the payment step, a \"Promo Code\" section is waiting for you there.",
  "userCouponsConditionsTitle": "Coupon conditions",
  "userCouponsConditionsCatalogue": "Across the entire catalogue.",
  "userCouponsConditionsNonCombinable": "This code cannot be combined with any other promotional code."
});
export const userCouponsAmountTitle = translateFormatter<{
  amount: string;
}>("{amount} off just for you", undefined, undefined, "en");
export const userCouponsAmountContent = translateFormatter<{
  minPurchase: string;
}>("Here's a lovely gift for your next purchase starting from {minPurchase}.", undefined, undefined, "en");
export const userCouponsConditionsDate = translateFormatter<{
  validUntil: string;
}>("Offer valid until {validUntil} inclusive.", undefined, undefined, "en");